import { fetchJSON } from '../utils/fetch.ts';

export const fetchLicenseInformation = (cloudId: string) =>
	fetchJSON(`/gateway/api/xflow/${cloudId}/license-information`);
